import { createEffect } from '@ngrx/effects';
import { inject } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { NavigationEnd, NavigationSkipped, Router } from '@angular/router';
import { RouteActions } from '../state/route/route.actions';
import { BreadcrumbService } from '@ui';

export const routerEvents$ = createEffect(
  (
    router = inject(Router),
    breadcrumbService = inject(BreadcrumbService),
  ) =>
    router.events.pipe(
      filter(
        (event): event is NavigationEnd | NavigationSkipped =>
          event instanceof NavigationEnd || event instanceof NavigationSkipped,
      ),
      map(() => {
        const root = router.routerState.snapshot.root;
        const breadcrumbs = breadcrumbService.buildBreadcrumbs(root);
        return RouteActions.setBreadcrumbs({ breadcrumbs });
      }),
    ),
  { functional: true },
);
